import { render, staticRenderFns } from "./PayoutLimitsContainer.vue?vue&type=template&id=7256add3&"
import script from "./PayoutLimitsContainer.vue?vue&type=script&lang=js&"
export * from "./PayoutLimitsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports